export default "__VITE_ASSET__DmMKLvWG__"